import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { usePaletteColor } from '../theme';
export const Icon = React.forwardRef((props, ref) => {
    const { color: colorProp = 'action.active', iconComponent, outlineComponent, roundedComponent, variant = 'rounded', border, sx, ...muiProps } = props;
    if (variant === 'outline' && !outlineComponent) {
        throw new Error('[Icon] outlineComponent is not provided');
    }
    if (variant === 'rounded' && !roundedComponent) {
        throw new Error('[Icon] roundedComponent is not provided');
    }
    const InnerIcon = (() => {
        switch (variant) {
            case 'filled':
                return iconComponent;
            case 'outline':
                return outlineComponent;
            case 'rounded':
                return roundedComponent;
        }
    })();
    const color = usePaletteColor(colorProp);
    return (_jsx(InnerIcon, { ref: ref, "data-role": "icon", fill: color, sx: {
            color,
            borderStyle: 'solid',
            borderWidth: border ? 1 : 0,
            borderRadius: variant === 'rounded' ? '50%' : 0,
            overflow: 'visible !important',
            ...sx
        }, ...muiProps }));
});
